import { render, staticRenderFns } from "./BreadcrumbRegister.vue?vue&type=template&id=83bd12ca"
import script from "./BreadcrumbRegister.vue?vue&type=script&lang=ts"
export * from "./BreadcrumbRegister.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports